import { render, staticRenderFns } from "./ourDashboard.vue?vue&type=template&id=1a308ead&"
import script from "./ourDashboard.vue?vue&type=script&lang=js&"
export * from "./ourDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ourDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports